import * as React from 'react';

const PaginationNextPrev = (props) => {
    const { pageCount, handlePageClick, page, limit, total = 0 } = props

    const startItem = page * limit + 1;
    const endItem = Math.min((page + 1) * limit, total);

    return (
        <div className="pagination-row mt-4 mb-4">
            <div className="pagination-wrapper">
                <ul className="pagination pagination-sm m-0 align-items-center">
                    
                        <li>
                            <a className={(page === 0 ? "bs5 btn btn-secondary btn-sm disabled" : "bs5 btn btn-secondary btn-sm")} onClick={() => handlePageClick({ selected:  (page - 1) })}>
                                PREV
                            </a>
                        </li>

                    <p className='mb-0 mt-0 mx-3'>{startItem} - {endItem} of {total}</p>

                        <li>
                            <a className={page >= (pageCount - 1) ? "bs5 btn btn-primary btn-sm disabled" : "bs5 btn btn-primary btn-sm"} onClick={() => handlePageClick({ selected: (page + 1) })}>
                                NEXT
                            </a>
                        </li>
                </ul>
            </div>
        </div>
    );
}

export default PaginationNextPrev;